var gMapsLoaded = false;
window.gMapsCallback = function(){
    gMapsLoaded = true;
    $(window).trigger('gMapsLoaded');
}
window.loadGoogleMaps = function(){
    if(gMapsLoaded) return window.gMapsCallback();
    var script_tag = document.createElement('script');
    script_tag.setAttribute("type","text/javascript");
    script_tag.setAttribute("src","https://maps.googleapis.com/maps/api/js?v=3.exp&sensor=false&callback=gMapsCallback");
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
    $('header nav img').css('z-index', 1000);
}

$(function(){

    // Google Maps
    function loadMap(){
        // Googlemaps
        google.maps.visualRefresh = true;
        var bedrijf = new google.maps.LatLng(52.734096, 6.191826); // (52.734096, 6.191826)

        var mapOptions = {
            zoom: 11,
            center: bedrijf,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles:
            [{
                featureType: 'poi.attraction', // poi
                elementType: 'labels',
                stylers:
                [{
                    visibility: 'off'
                }]
            },
            {
                // stylers:[
                //     { hue: "#000" },
                //     { saturation: -30 }
                // ]
                stylers:[
                    { hue: "#000" },
                    // { saturation: 0 }
                    {
                        "saturation": -100
                    },
                    {
                        "gamma": 1
                    }
                ]
            }]
        };

        map = new google.maps.Map(document.getElementById('map-canvas'),mapOptions);

        var infoMarker  = '<b><i></i> IJsmakers</b><br>';
            infoMarker += '<i></i> Kruisstraat 25<br>';
            infoMarker += '<i></i> 7941 AM&nbsp; Meppel<br>';
            infoMarker += '<i></i> <a href="tel:+31522246249">0522 - 246 249</a><br>';
            infoMarker += '<i></i> <a href="mailto:info@ijsmakers.nl">info@ijsmakers.nl</a><br>';

        var infoMarkerStaphorst  = '<b><i></i> IJsmakers</b><br>';
            infoMarkerStaphorst += '<i></i> Ebbinge Wubbelaan 1<br>';
            infoMarkerStaphorst += '<i></i> 7951 AA&nbsp; Staphorst<br>';
            infoMarkerStaphorst += '<i></i> <a href="tel:+31522769032">0522 - 769 032</a><br>';
            infoMarkerStaphorst += '<i></i> <a href="mailto:info@ijsmakers.nl">info@ijsmakers.nl</a><br>';

        var infoMarkerSteenwijk  = '<b><i></i> IJsmakers</b><br>';
            infoMarkerSteenwijk += '<i></i> Markt 32<br>';
            infoMarkerSteenwijk += '<i></i> 8331 HJ&nbsp; Steenwijk<br>';
            infoMarkerSteenwijk += '<i></i> <a href="tel:+31521769052">0521 - 769 052</a><br>';
            infoMarkerSteenwijk += '<i></i> <a href="mailto:info@ijsmakers.nl">info@ijsmakers.nl</a><br>';

var infoMarkerWveen  = '<b><i></i> IJsmakers</b><br>';
            infoMarkerWveen += '<i></i> Veneweg 103c<br>';
            infoMarkerWveen += '<i></i> 7946 LH&nbsp; Wanneperveen<br>';

            infoMarkerWveen += '<i></i> <a href="mailto:info@ijsmakers.nl">info@ijsmakers.nl</a><br>';

        var infoMarkertje = [
            [infoMarker],
            [infoMarkerStaphorst],
            [infoMarkerSteenwijk],
            [infoMarkerWveen],
        ]

        var markers = [
            ['Meppel', 52.699305, 6.189101, 'hoi'],
            ['Staphorst', 52.646751, 6.207536, 'hoi'],
            ['Steenwijk', 52.786632, 6.115866, 'hoi'],
            ['Wanneperveen', 0, 0, 'hoi'],
        ];

        var image = {
            url: '/assets/pointer.png'
        };

        var infowindow = new google.maps.InfoWindow(), marker, i;
        for (i = 0; i < markers.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(markers[i][1], markers[i][2]),
                map: map,
               // icon: image
            });
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    if(i == 0){
                        infowindow.setContent(infoMarker);
                    }
                    if(i == 1){
                        infowindow.setContent(infoMarkerStaphorst);
                    }
                    if(i == 2){
                        infowindow.setContent(infoMarkerSteenwijk);
                    }
                    if(i == 3){
                        infowindow.setContent(infoMarkerWveen);
                    }
                    infowindow.open(map, marker);
                }
            })(marker, i));
        }


        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map, marker);
        });

        google.maps.event.addDomListener(map, 'tilesloaded', function(){
            $('.gm-style-cc').hide();
        });

        map.setOptions({'scrollwheel': true, 'draggable': true});

        // var marker = new google.maps.Marker({
        //     map: map,
        //     position: map.getCenter()
        // });

        // var infowindow = new google.maps.InfoWindow();
        // infowindow.setContent(infoMarker);

        // google.maps.event.addListener(marker, 'click', function() {
        //     infowindow.open(map, marker);
        // });

        // google.maps.event.addDomListener(map, 'tilesloaded', function(){
        //     $('.gm-style-cc').hide();
        // });

        // map.setOptions({'scrollwheel': true, 'draggable': false});
    }

    if( $('div#map-canvas').hasClass('yolo') ){
        $(window).bind('gMapsLoaded', loadMap);
        window.loadGoogleMaps();
    }

})
